export const cilWalk = ["24 24","<path d='M16.003 3.236c0.338 0.815-0.049 1.75-0.865 2.088s-1.75-0.049-2.088-0.865c-0.338-0.815 0.049-1.75 0.865-2.088s1.75 0.049 2.088 0.865z'></path><path d='M16.566 9.375l-1.472-2.65-2.84-0.967-3.638 1.323c-0.435 0.163-0.739 0.574-0.741 1.057v2.737h1.5v-2.475l2.288-0.832-4.228 13.057h1.576l2.348-7.304 0.369 0.12 1.772 3.249v3.934h1.5v-4.029c-0-0.198-0.051-0.383-0.14-0.545l0.003 0.006-1.761-3.228 1.357-4.159 0.903 1.626c0.196 0.348 0.563 0.578 0.983 0.579h2.404v-1.5z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-walk.js
// module id = null
// module chunks = 